import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { SPUserComponent } from './components/spUser/sp-user.component';

export class SPUserRoutingStates {
  public static readonly LIST = {
    url: 'spuser'
  };
}

export const UserRoutes: Routes = [
  {
    path: SPUserRoutingStates.LIST.url,
    data: {
      page: {
        title: 'SP User Management'
      },
      requiresRole: [Groups.SPM_USER_MANAGER]
    },
    component: SPUserComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(UserRoutes)]
})
export class SPUserRoutingModule {}
